export enum RequestStatus {
  Pending = "pending",
  Fulfilled = "fulfilled",
  Rejected = "rejected",
}
